import { getUserLocation } from '../js/aMapApi.js'
// import {queryLocation,convertMovieLocationToItemRegion} from "@/api/index.js";
export default {
  data() {
    return {
      selectCityList: [],
      municipalityDirectlyId: [304447, 308639, 334393, 306077], //直辖市
      user: sessionStorage.getItem('user')
    }
  },
  computed: {},
  mounted() {
    var user = sessionStorage.getItem('user')
    user && (this.user = JSON.parse(user))
  },
  watch: {},
  methods: {
    //获取所有城市列表
    getQueryLocation() {
      return new Promise((resolve, reject) => {
        if (this.selectCityList.length || (this.$store.state.festival_cityList && this.$store.state.festival_cityList.length)) {
          resolve(true)
        }
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server
          .queryLocation({}, headers)
          .then((res) => {
            this.$store.commit('setCityList', res.data.default)
            this.selectCityList = res.data.default
            resolve(true)
          })
          .catch((err) => {
            resolve(false)
          })
      })
    },
    //匹配用户城市是否在城市
    getMatchingCity(res) {
      let userCity = ''
      let cityList = this.$store.state.festival_cityList.filter((item) => item.locationType === 2)
      userCity = cityList.find((val) => val.nameCn === res.city || val.nameCn.includes(res.city))
      return userCity
    },
    //获取定位超时配置超时时间
    getSetTimeOutLocation(time = 2000, callback) {
      let timer = null
      let isTimeOut = false
      return new Promise((reslove, reject) => {
        timer = setTimeout(() => {
          isTimeOut = true
          reslove(null)
        }, time)
        getUserLocation()
          .then((res) => {
            clearTimeout(timer)
            if (isTimeOut) {
              //定位成功并且超时回调处理
              callback && callback(res)
              reject()
            } else {
              reslove(res)
            }
          })
          .catch(() => {
            console.log('定位失败1')
            reslove(null)
          })
      })
    },
    //转换中台城市地址 type 为空 获取全部信息 id:获取城市cityId
    getAdressToCity(locationId, type = '') {
      return new Promise((reslove, reject) => {
        var headers = {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: this.user.token
        }
        this.$server.convertMovieLocationToItemRegion({ cityId: locationId }, headers).then((res) => {
          if (res.code === 0) {
            if (type == 'cityId') {
              let { province, city } = res.data
              if (this.municipalityDirectlyId.includes(province.id)) {
                reslove(province.id)
              } else {
                reslove(city.id)
              }
            } else {
              reslove(res.data)
            }
          }
        })
      })
    }
  }
}
